module.exports = __webpack_public_path__ + "static/media/bearbnb.a91cc70d.JPG";